import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

export default function LoginPage() {
  return (
    <>
      <Navbar />

      <main className="flex flex-col items-center justify-center min-h-screen py-12 bg-gray-50 dark:bg-neutral-900 px-4">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-800 dark:text-white mb-2">
            Welcome Back to Blessed Montessori School Portal
          </h2>
          <p className="text-gray-600 dark:text-gray-300 text-sm max-w-md mx-auto">
            We're glad to have you back. Please click the button below to log in to your account and continue your journey with us.
          </p>
        </div>

        <a
          href="https://schoolifix.com/signin"
          target="_blank"
          rel="noopener noreferrer"
          className="px-6 py-3 text-white bg-blue-600 hover:bg-blue-700 rounded-lg text-sm font-medium transition duration-300"
        >
          Go to Login Page
        </a>
      </main>

      <Footer />
    </>
  )
}
